import React from 'react'
import Visa from '../../assets/images/payment-methods/visa-icon.svg'
import MasterCard from '../../assets/images/payment-methods/mastercard-icon.svg'
import ApplePay from '../../assets/images/payment-methods/applepay-icon.svg'
import GooglePay from '../../assets/images/payment-methods/googlepay-icon.svg'

const FooterContact = () => {
  return (
    <section className="footer__contact flex-container flex-column">
      <h3>Haben Sie Fragen?</h3>
      <a href="tel:+436601919689" className="footer__contact__link">
      <p>+43 660 19 19 689</p>
      </a>
      <a href="mailto:casa.itzling@gmail.com" className="footer__contact__link">
      <p>casa.itzling@gmail.com</p>
      </a>
      <section className="footer__contact__payments">
        <img width="50" height="50" src={Visa} alt="Visa card" />
        <img width="50" height="50" src={MasterCard} alt="Mastercard card" />
        <img width="50" height="50" src={ApplePay} alt="Apple pay" />
        <img
          width="50"
          height="50"
          className="googlepay"
          src={GooglePay}
          alt="Google pay"
        />
      </section>
    </section>
  )
}
export default FooterContact;
